import ApplicationError from '@/core/misc/ApplicationError';
import { ErrorSeverity } from '@/core/misc/ErrorSeverity';

/**
 * Валидационная ошибка — ожидаемое нарушение бизнес-правил.
 *
 * Показывается пользователю как предупреждение, в Sentry не репортится.
 * Используется когда данные некорректны но ситуация штатная.
 *
 * @example
 * throw new ValidationError('Не указан получатель платежа');
 */
class ValidationError extends ApplicationError {
    constructor(message: string, debugData: unknown = null) {
        super(message, -32511, ErrorSeverity.Notice, debugData);
        this.name = 'ValidationError';
    }
}

export default ValidationError;